import { User, useAuth0 } from '@brighte/passwordless-authenticator';
import { getApplicantTypeAndTrackingIdFromUrl } from '../utils';
import { AnalyticsEvent } from './constants';
import {
  getEventNameByStep,
  identifyAnalyticsUser,
  trackAnalyticsEvent,
  transformAnalyticsPayloadByStep,
  transformBaseAnalyticsPayload,
} from './helpers';
import { useAnalyticsActions } from './provider';

type IdentifyTraits = {
  mobile?: string;
} & User;

export function useAnalytics() {
  const { eventProperties, setEventProperties } = useAnalyticsActions();

  const { user } = useAuth0();

  const trackAndIdentifySignIn = async () => {
    const { email, given_name, family_name, role, uid } = user as IdentifyTraits;
    const traits = {
      brighte_id: user?.userId,
      email: email,
      first_name: given_name,
      last_name: family_name,
      role_type: role,
    };

    identifyAnalyticsUser(uid, traits);
    trackAnalyticsEvent(AnalyticsEvent.SignedIn, traits);
  };

  const getEventHistory = (currentPage, stepPayload) => {
    const index = eventProperties.findIndex(item => currentPage === item.page);
    if (index >= 0) {
      return [...eventProperties.slice(0, index), { page: currentPage, data: stepPayload }];
    }

    return [...eventProperties, { page: currentPage, data: stepPayload }];
  };

  const trackSubmissionEvents = ({ quote, formValues, currentPage, user }) => {
    const { trackingId } = getApplicantTypeAndTrackingIdFromUrl();
    if (!quote || !formValues || !currentPage || !user) return;

    const baseAnalyticsData = transformBaseAnalyticsPayload({ quote, formValues, user });
    const eventName: AnalyticsEvent = getEventNameByStep(currentPage);
    const stepPayload = transformAnalyticsPayloadByStep({
      currentPage,
      formValues,
      quote,
    });

    // store previous step payload to carry over on next event
    const payloadHistory = getEventHistory(currentPage, stepPayload);
    setEventProperties([...payloadHistory]);

    const payload = payloadHistory.reduce((res, value) => {
      const item = value.data;
      return { ...res, ...item };
    }, {});

    trackAnalyticsEvent(eventName, {
      ...baseAnalyticsData,
      ...payload,
      tracking_id: trackingId,
    });
  };

  return { trackAndIdentifySignIn, trackSubmissionEvents };
}
